import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'googleTagManagerKey',
  initialState: null as null | string,
  reducers: {
    setGoogleTagManagerKey(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setGoogleTagManagerKey } = slice.actions;

export default slice.reducer;
